import { useEffect, useState } from "react";
import { activeShiftAt } from "./production-time";

export function useActiveShift() {
  const [shiftCode, setShiftCode] = useState(() => activeShiftAt());
  useEffect(() => {
    const update = () => setShiftCode(activeShiftAt());
    const interval = window.setInterval(update, 30_000);
    return () => window.clearInterval(interval);
  }, []);
  return shiftCode;
}
